import React from "react";
import { Box } from "@mui/material";
import { Icon } from "@iconify/react";

const IconBox = ({
  icon,
  size = 24,
  iconSize = 18,
  bgColor = "#FFF5FF",
  iconColor = "#572575",
  radius = "4px",
}) => {
  return (
    <Box
      width={size}
      height={size}
      bgcolor={bgColor}
      borderRadius={radius}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Icon
        icon={icon} // Use the imported icon
        width={iconSize}
        height={iconSize}
        color={iconColor}
      />
    </Box>
  );
};

export default IconBox;
